<div class="select-partner-step-container">
  <div class="select-partner-step-content">
    <sg-text class="investigate-title" color="text-placeholder" variant="sg-h3">What are you investigating today?</sg-text>
    <form pbl-nform #selectPartnerForm [model]="inspectorFormModel" [filter]="relevantFields" filterMode="include" (beforeRender)="beforeFormRender($event)">
      <div *nFormOverride="'fileType'; let ctx">
        <div class="step-input-label-container">
          <sg-text class="step-number" color="decorative-text-02" variant="sg-p3-standard">1</sg-text>
          <sg-text color="text-secondary" variant="sg-p3-strong">Select the type of file you’d like to investigate:</sg-text>
        </div>
        <mat-radio-group [formControl]="ctx.fControl" name="investigateType" class="investigate-type-container" disableRipple="true">
          <mat-radio-button value="Swift Forwarding" checked="true">SWIFT Forwarding</mat-radio-button>
          <mat-radio-button disabled value="Instructions">Instructions (Coming Soon)</mat-radio-button>
          <mat-radio-button disabled value="SFR">SFR (Coming Soon)</mat-radio-button>
        </mat-radio-group>
      </div>
      <div *nFormOverride="'partnerOrClient'; let ctx" class="partner-or-client-form-control">
        <div class="step-input-label-container">
          <sg-text class="step-number" color="decorative-text-02" variant="sg-p3-standard">2</sg-text>
          <sg-text color="text-secondary" variant="sg-p3-strong">Select Partner or Client:</sg-text>
        </div>
        <ng-container *ngTemplateOutlet="renderer; context: { $implicit: ctx, dynForm: selectPartnerForm }"></ng-container>
        @if (clickedAndInvalid && ctx.fControl.invalid) {
        <sg-text class="partner-required-error-message" variant="sg-p2" color="text-error">Select partner or client to start investigation</sg-text>
        }
      </div>
    </form>
  </div>
  <div class="select-partner-step-footer">
    <sg-button
      (click)="startInvestigationClicked()"
      class="start-investigation-button"
      size="medium"
      text="Start Investigation"
      icon="search"
      variant="primary"></sg-button>
  </div>
</div>
<ng-template #renderer let-ctx let-dynForm="dynForm">
  <material-form-control-renderer
    [nFormCmp]="dynForm"
    [nForm]="ctx.nForm"
    [fArray]="ctx.fArray"
    [fControl]="ctx.fControl"
    [fGroup]="ctx.fGroup"
    [item]="ctx.item"></material-form-control-renderer>
</ng-template>
